/**
 * Extrait le domaine propre depuis une URL
 * @param siteUrl - URL du site web
 * @returns Domaine nettoyé (ex: "google.com")
 */
function extractDomain(siteUrl: string): string {
  if (!siteUrl) return '';

  return siteUrl
    .replace(/^https?:\/\//, '')  // Enlever protocole
    .replace(/^www\./, '')         // Enlever www.
    .split('/')[0];                // Garder seulement le domaine
}

/**
 * Génère l'URL du logo d'une entreprise via Brandfetch CDN
 * @param siteUrl - URL du site web (ex: "https://google.com")
 * @returns URL du logo via Brandfetch CDN
 */
export function getBrandfetchLogoUrl(siteUrl: string): string {
  if (!siteUrl) return '';

  const domain = extractDomain(siteUrl);
  const clientId = '1idSb4hkcSOMOCTBdBP';

  // Utiliser le CDN direct de Brandfetch (pas besoin d'API call)
  return `https://cdn.brandfetch.io/${domain}?c=${clientId}`;
}

/**
 * Extrait le nom de l'entreprise depuis l'URL pour créer des initiales
 * @param siteUrl - URL du site web
 * @returns Initiales de l'entreprise (ex: "google.com" → "GO")
 */
export function getCompanyInitials(siteUrl: string): string {
  if (!siteUrl) return '';

  const domain = siteUrl
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0]
    .split('.')[0]; // Prendre seulement le nom (avant le TLD)

  // Retourner les 2 premières lettres en majuscules
  return domain.substring(0, 2).toUpperCase();
}
